
// SELECTORS
var _result = $('.uppresult');
var _allevents = $('#all-events');
var _container = $('#uppcontent');
var _signup = $('#signup-form');
var _edit = $('#edit-form');
var _login = $('#login-form');
var _lost = $('#lost-form');
var _reset = $('#reset-form');
var _dashboard = $('#uppdashboard');
var _verify = $('#verify-form');
var _dashbuttons = $('.myitems');
var _subscriptions = $('#subscriptions');
var _eventsearch = $('#event-search');
var _eventsNav = $('#events-nav');
var _changeemail = $('#changeemail-form');
var _ticketspage = $('#tickets-app');
var _updatesGuest = $('#updates-guest');
var _newpoints = $('#newpoints');
var _ppprotect = $('#ppprotect');
var _meter = '<div class="meter"><i></i></div>';
var _loginmodal = $('#loginmodal');
var _calcpoints = $('.calcpoints');
var _ut = $('#ut');
var _utbody = $('#ut>tbody');
var _betaform = $('#beta-signup');

